import React from 'react';
import '../../pages/AdminDashboard.css'; // Make sure it can access the styles

const AiStatusCell = ({ aiStatus }) => {
    if (!aiStatus) {
        return <span className="ai-status-badge status-not-processed">NOT PROCESSED</span>;
    }

    let className = 'ai-status-badge';
    let text = aiStatus.replace(/_/g, ' ').toUpperCase();

    switch (aiStatus) {
        case 'approved_by_ai':
            className += ' status-approved';
            break;
        case 'rejected_harmful':
        case 'duplicate':
            className += ' status-rejected';
            break;
        case 'needs_manual_review':
            className += ' status-pending';
            break;
        default:
            className += ' status-not-processed';
            break;
    }

    return <span className={className}>{text}</span>;
};

export default AiStatusCell;